<template>
    <div class="h-100">
        <div v-if="isLoading && isStreamEmpty" class="d-flex justify-content-center align-items-center h-100">
            <b-spinner class="align-middle" variant="secondary" />
        </div>
        <div v-else>
            <b-container fluid class="max-width">
                <title-back-button 
                    :title="stream.title"
                    :show-breadcrumbs="true"
                    :prev-page="trans('streams.back')"
                    :prev-page-link="{name: this.prevRouteName}"
                />
                <streams-dashboard :stream="stream" :is-loading="isLoading" />
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import StreamsDashboard from '../organisms/StreamsDashboard.vue';
    import TitleBackButton from '../molecules/TitleBackButton';
    export default {
        components: { StreamsDashboard, TitleBackButton },
        name: "StreamsContainer",
        data() {
            return {
                prevRouteName: ''
            }
        },

        methods: {
            ...mapActions({
                loadStream: 'streams/loadStream',
            })
        },

        computed: {
            ...mapGetters({
                stream: 'streams/getCurrentStreamData',
                isLoading: 'streams/getStreamLoading',
                isStreamEmpty: 'streams/getIsStreamEmpty'
            }),
            currentStreamid() {
                return this.$route.params.id
            }
        },

        mounted() {
            this.loadStream(this.currentStreamid);
            trackEvent('StreamDashboardView', {
                stream: this.currentStreamid
            })
        },

        watch:{
            $route (to, from){
                this.loadStream(this.currentStreamid);
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRouteName = from.name === 'stream-detail' ? 'stream-detail' : 'servicedashboard';
            })
        }
    }
</script>
